module.exports = __webpack_public_path__ + "static/img/Stefano-Utoikamanu.9e46cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stefano-Utoikamanu.jpg
// module id = X1Qd
// module chunks = 0